import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const bankdealerApi = createApi({
  reducerPath: "bankdealerApi",
  baseQuery,
  tagTypes: ["bankdealer"],
  endpoints: (builder) => ({


    // createBankdealer: builder.mutation({
    //   query: ({ id, ...data }) => ({
    //     url: `customer/CustomeBankDealer/${id}`,
    //     method: "PUT",
    //     headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
    //     body: { customeBankDealer: data , BankName: Bank${index + 1}},
    //   }),
    //   invalidatesTags: ["bankdealer"],
    // }),

    createBankdealer: builder.mutation({
        query: ({ id, index, ...data }) => ({
          url: `customer/CustomeBankDealer/${id}`,
          method: "PUT",
          headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
          body: { customeBankDealer: data },
       
        }),
        invalidatesTags: ["bankdealer"],
      }),
      
    // Updated Export Table

    updateBankdealer: builder.mutation({ ///v1/customer/CustomeBankDealer/{CustomerId}/{CustomeBankDealerId}
      query: ({ id, subId, ...data }) => ({
        url: `customer/CustomeBankDealer/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { customeBankDealer: data },
      }),
      invalidatesTags: ["bankdealer"],
    }),



    getBankdealerbyId: builder.query({
      query: ({ id }) => `customer/CustomeBankDealer/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item) => ({
          ...item,
          id: item.customeBankDealerId,
        }));
      },
      providesTags: ["bankdealer"],
    }),

    // 🔹 Get single invoice by Id
    getBankdealerId: builder.query({
      query: ({ id, subId }) =>
        `customer/CustomeBankDealer/${id}/${subId}`,
      transformResponse: (response) => response?.data ?? null,


      providesTags: ["bankdealer"],
    }),

    deleteBankdealer: builder.mutation({
      query: ({ id }) => ({
        url: `customer/CustomeBankDealer/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["bankdealer"],
    }),


    
  })
});
export const {
    useCreateBankdealerMutation,
    useUpdateBankdealerMutation,
    useLazyGetBankdealerbyIdQuery,
    useLazyGetBankdealerIdQuery,
    useDeleteBankdealerMutation


 

} = bankdealerApi;


